import { action, computed, makeObservable, observable } from 'mobx';
import DownloadTask, { DownloadTaskParams } from './DownloadTask';

export default class MarkupsPSDDownloadTask extends DownloadTask {
	constructor( { id, messagingService, downloadInitializer }: DownloadTaskParams ) {
		super( { id, messagingService, downloadInitializer } );

		makeObservable( this, {
			title: computed,
			countText: computed,
			count: observable,
			total: observable,
			status: observable,
			errors: computed,
			progressPercent: computed,
			hasFinished: computed,
			observeDownloadFromBackend: action,
			cancel: action,
			onDownloadEventReceived: action
		} );
	}

	get title() {
		return 'Generating Markups PSD';
	}

	get countText() {
		if ( this.status === 'unknown' ) return 'Preparing...';
		if ( this.status === 'successful' ) return 'Done';
		if ( this.status === 'failed' ) return 'Error Downloading';
		if ( this.status === 'canceled' ) return 'Canceled';

		return `${this.progressPercent.toFixed( 0 )}%`;
	}
}
